<template>
  <div class="the-navbar__user-meta flex items-center" v-if="activeUserInfo.displayName">

    

    <vs-dropdown vs-custom-content vs-trigger-click class="flex cursor-pointer">
      <div class="text-right leading-tight mt-1 hidden sm:block">
        <p class="font-semibold">{{ activeUserInfo.displayName }}</p>
        <small>Content Creator</small>
      </div>
      <div class="con-img ml-3">
        <img v-if="activeUserInfo.photoURL" key="onlineImg" :src="activeUserInfo.photoURL" alt="user-img" width="40" height="40" class="rounded-full shadow-md cursor-pointer block" />
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 9rem">
          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="logoutUser">
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Logout</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  data() {
    return {

    }
  },
  computed: {
    activeUserInfo() {
      const user = this.$store.getters['users/getUserProfile']
      return {
        displayName: `${user.first_name} ${user.last_name}`,
        photoURL: user.avatar
      }
    }
  },
  methods: {
    ...mapActions('users', ['logout']),
    async logoutUser() {
      await this.logout()
      this.$router.push('/login').catch(() => {})
    },
  }
}
</script>
